import React from "react";
import useResponsive from "../../core/hooks/useResponsive";
import ThreeColumn from "../../core/layouts/ThreeColumn";
import { TwoColumn, TwoRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";

const UploadImageLayoutStyle = {
  imageWrapperStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    justifyContent: variables.spaceBetween,
  },
  imageWrapperStyleForMobile: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    justifyContent: variables.justifyCenter,
  },
  leftSectionWrapperStyle: {
    gap: "1.875rem",
    alignItems: variables.alignCenter,
  },
  topSectionUploadImageWrapperStyle: {
    gap: variables.gapXS1,
    alignItems: variables.alignCenter,
    justifyContent: variables.justifyCenter,
  },
  bottomSectionStyle: {
    marginTop: variables.marginLg3,
  },
};

export default function UploadImageLayout({
  leftSection,
  rightSection,
  middleSection,
  leftSubSection,
  leftSectionStyle,
  middleSectionStyle,
  rightSectionStyle,
}) {
  const responsive = useResponsive();
  return responsive?.isMd ? (
    <ThreeColumn
      style={UploadImageLayoutStyle.imageWrapperStyle}
      leftSection={
        <TwoColumn
          style={UploadImageLayoutStyle.leftSectionWrapperStyle}
          leftSection={leftSection}
          rightSection={leftSubSection}
        />
      }
      leftSectionStyle={leftSectionStyle}
      rightSection={rightSection}
      middleSection={middleSection}
      middleSectionStyle={middleSectionStyle}
      rightSectionStyle={rightSectionStyle}
    />
  ) : (
    <TwoRow
      style={UploadImageLayoutStyle.imageWrapperStyleForMobile}
      topSection={
        <TwoRow
          style={UploadImageLayoutStyle.topSectionUploadImageWrapperStyle}
          topSection={leftSection}
          bottomSection={leftSubSection}
        />
      }
      bottomSection={rightSection}
      bottomSectionStyle={UploadImageLayoutStyle.bottomSectionStyle}
    />
  );
}
